module.exports = __webpack_public_path__ + "static/media/MainHeader@3x.a3feea94.png";